// eslint-disable-next-line no-restricted-imports
import { Pagination } from '@mui/material';
import { getColor } from 'helpers';

import { CSSObject, styled } from '../styled';
import { ColorsDark, ColorsLight } from '../theme';

export const PaginationStyled = styled(Pagination)(({ theme }) => ({
  '&.MuiTablePagination-actions': {
    margin: 0,
  },

  '.MuiPaginationItem-outlined': {
    borderRadius: 8,
    border: 0,
    margin: 2,
    height: 32,
    width: 32,
    color: theme.palette.text.gray,
    fontSize: 14,

    '&.Mui-selected': {
      background: 'none',
      border: `1px solid ${getColor(theme, {
        dark: ColorsDark.gray200,
        light: ColorsLight.gray150,
      })}`,
      color: theme.palette.text.primary,
      fontWeight: 700,
    } as CSSObject,
  } as CSSObject,

  '.MuiPaginationItem-ellipsis': {
    paddingTop: 6,
  },
}));
